
export const keywordAnalyzerStyle = theme => ({
    gridContent: {
        marginBottom: '0px'
    },
    paper: {
        padding: theme.spacing(2),
        display: 'flex',
        overflow: 'auto',
        flexDirection: 'column',
    },
    fixedHeight: {
        height: '100%',
        backgroundColor: '#f3f3f3'
    },
    contentAll: {
        [theme.breakpoints.up('sm')]: {
            height: 'calc(100vh - 64px)'
        },
        overflow: 'auto'
    },
    contentOptions: {
        textAlign: 'left'
    },
    actionContainer: {
        flex: 1,
        display: 'flex',
        flexDirection: 'row',
        justifyContent: 'flex-end',
        alignItems: 'center',
        padding: '0px 62px'
    },
    menuContentEditable:{
        borderTop: '1px solid #d3d3d3',
        borderLeft: '1px solid #d3d3d3',
        borderRight: '1px solid #d3d3d3',
        borderBottom: '0px',
        boxShadow: 'inset 1px 1px 0px #e3e3e3',
        borderRadius: '5px 5px 0px 0px'
    },
    contentEditable: {
        display: "block",
        paddingBottom: '0px',
        height: " 400px",
        overflowY: 'scroll',
        "&:focus-visible": {
            border: '1px solid #AEAAAA',
            backgroundColor: '#fff',
            boxShadow: 'inset 1px 1px 7px #e3e3e3',
            padding: '10px',
            borderRadius: '0px 0px 5px 5px',
            outline: "0px"
        },
        '& xprt': {
            background: "#fbc02d",
            color: "#000"
        },
        border: '1px solid #d3d3d3',
        backgroundColor: '#fff',
        boxShadow: 'inset 1px 1px 7px #e3e3e3',
        padding: '10px',
        borderRadius: '0px 0px 5px 5px'
    },
    highlighedTerms: {
        display: 'inline-flex',
        marginLeft: '10px'
    },
    highlighedTermsStrong: {
        display: 'inline-flex',
        marginLeft: '10px',
        fontWeight: "bold"
    },
    highlighedColor: {
        '& span': {
            background: "#fbc02d"
        }
    },
    chipFound: {
        backgroundColor: '#cce4ff',
        color: 'black',
        fontWeight: '700',
        margin: '4px',
        borderColor: '#84a6cd',
        fontSize: '14px'
    },
    chip: {
        backgroundColor: '#7c7c7c',
        fontSize: '12px',
        margin: '4px',
        color: '#fff'
    },
    menuItem: {
        '& div': {
            minWidth: "25px"
        }
    },
    linearProgress: {
        paddingTop: '0px',
        marginLeft: '2px',
        marginRight: '2px',
        borderRadius: '10px',
        overflow: 'hidden',
        marginTop: '-5px',
    },
    tools: {
        padding: '0px',
        margin: '0px',
        background: '#333',
        borderRadius: '3px',
        position: 'absolute',
        top: 0,
        left: 0,
        transform: 'translate(-50%, -100%)',
        transition: '0.2s all',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        color: '#fff',
        cursor: "pointer",
        fontWeight: 700,
        '&::after': {
            content: '""',
            position: 'absolute',
            left: '50%',
            top: '-5px',
            transform: 'translateX(-50%)',
            width: 0,
            height: 0,
            borderLeft: '6px solid transparent',
            borderRight: '6px solid transparent',
            borderBottom: '6px solid #333',
        }
    },
    buttonAddKeyword: {
        color: '#fff',
        fontSize:"12px",
        padding:"5px 10px",
        display:"inline-block",
        "&:disabled": {
            color: '#C3C7CB',
          }
    },
    buttonAddKeywordIcon: {
        fontSize: '20px'
    },
    progressAdd: {
        color: '#fff',
        marginLeft: '5px',
        marginRight: '5px'
    },
    progressAddMultiple: {
        color: '#000',
        marginLeft: '5px',
        marginRight: '5px'
    },
    progressSave: {
        color: 'rgba(0, 0, 0, 0.26)',
        marginRight: '8px'
    },
    alert:{
        whiteSpace: "pre-line"
    }
})